import { createFileRoute } from '@tanstack/react-router';
import { IdentityVerificationsListPage } from './IdentityVerificationsListPage';

export const Route = createFileRoute('/_protected/admin/internal-tools/identity-verifications/')({
  component: IdentityVerificationsListPage,
});
